// extracted by mini-css-extract-plugin
export default {"plansContainerOuter":"cXWZBH9Ux","plansContainer":"cJ1XP3HHi","ps":"cKPXQ0nhD"};